export enum API {
	TRANSFER_TRACKING = 'TRANSFER_TRACKING'
}

export function getBaseUrl(code: API): string {
	switch (code) {
		case API.TRANSFER_TRACKING:
			return process.env.REACT_APP_API_URL;
		default:
			return code;
	}
}
